
    import '/home/ec2-user/Youlify-Design/docs/react/getting-started.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/home/ec2-user/Youlify-Design/docs/react/getting-started.en-US.md?type=demo')
};